export default "__VITE_PUBLIC_ASSET__ab560b24__"